import { API } from "@/services"

export const REDIS_CACHE_ENDPOINTS = {
  passOrFail(params={}){
    return API.Axios.callstats.v1.request({
      url: `redis-cache/crash`,
      method: 'GET',
      params,
    })
  },
}